import { TableColumnType } from 'src/types/table';

export const xchangeKeys: { [key: string]: string } = {
    RECIPIENT_NAME: 'RECIPIENT_FULLNAME',
    BILLING_NAME: 'BILLING_FULLNAME',
    BILLING_ADDRESS_ADDITIONAL_INFO: 'BILLING_STREET_ADDITIONAL_INFO',
    COUNT: 'COUNT_PRODUCT',
    ZASILKOVNA_ADDRESS_ID: 'ADDRESS_ID',
};

export const orderDataKeys = [
    'ESHOP_ORDER_ID',
    'RECIPIENT_NAME',
    'RECIPIENT_STREET',
    'RECIPIENT_ADDRESS_ADDITIONAL_INFO',
    'RECIPIENT_ATTENTION_NAME',
    'RECIPIENT_CITY',
    'RECIPIENT_STATE',
    'RECIPIENT_PROVINCE_CODE',
    'RECIPIENT_POST_CODE',
    'RECIPIENT_EMAIL',
    'RECIPIENT_COMPANY_NAME',
    'RECIPIENT_PHONE',
    'RECIPIENT_GLN',
    'BILLING_NAME',
    'BILLING_EMAIL',
    'BILLING_COMPANY_NAME',
    'BILLING_STREET',
    'BILLING_ADDRESS_ADDITIONAL_INFO',
    'BILLING_CITY',
    'BILLING_STATE',
    'BILLING_PROVINCE_CODE',
    'BILLING_POST_CODE',
    'BILLING_PHONE',
    'BILLING_GLN',
    'BILLING_ATTENTION_NAME',
    'PAYMENT_METHOD',
    'PRICE',
    'CURRENCY',
    'SHIPPER',
    'SHIPPER_SERVICE_CODE',
    'SHIPPING_PRICE',
    'COD_PRICE',
    'COD_CURRENCY',
    'COD_REF_NUMBER',
    'ADDRESS_ID',
    'BRANCH_ID',
    'STATUS',
    'HOLD_BY_QUALITY',
    'PICK_FROM_CUSTOMS_WAREHOUSE',
];

export const productTableColumns: TableColumnType[] = [
    { key: 'SKU', label: 'SKU', customRender: true },
    { key: 'COUNT', label: 'COUNT', customRender: true },
    { key: 'PRODUCT_PRICE', label: 'PRODUCT_PRICE', customRender: true },
    { key: 'CUSTOMS_PRODUCT_TYPE', label: 'CUSTOMS_PRODUCT_TYPE' },
];
